import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Card = ({ children, boxShadow, className, cardClassName, column }) => {
  return (
    <div className={classnames('Card panel panel-default', cardClassName)}>
      <div className={classnames('panel-body flex', { 'box-shadow': boxShadow }, { column }, className)}>
        { children }
      </div>
    </div>
  );
};

Card.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array
  ]),
  boxShadow: PropTypes.bool
};

export default Card;
